import {
  STATUS_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");

export const basicFormData = () => ({
  inputData: {
    reason: "",
    descriptions: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "fault_reason_masters",
    schema: schema,
    inputData: {
      reason: "",
      descriptions: "",
      created_by: "",
      updated_by: "",
      is_active: true,
    },
    moduleWhereCondition: {
      is_active: true,
    },
  };

  const navigatePage = { back: "/fault-reason-list" };

  const headerName = "Fault Reason";

  const validationType = "FaultReasonCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = (type) => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "fault_reason_masters",
    schema: schema,
  };

  const columnData = [
    { label: "Sr. No", value: "index" },
    { label: "Reason", value: "reason" },
    { label: "Descriptions", value: "descriptions" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/fault-reason-create",
    edit: "/fault-reason-create",
    view: "/fault-reason-view",
  };

  const searchfields = ["reason", "descriptions"];

  const headerName = "Fault Reason";
  const endpoint = "/getRecords";
  const exportFileName = "FaultReasonData.xlsx";

  const filterConfig = [STATUS_FILTER];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};
